import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
// Lazy load Handsontable to avoid blocking drawer open with massive bundle
const HandsontableSheetEditor = /*#__PURE__*/ lazy(()=>import('./sheet-handsontable-adapter-simple').then((mod)=>({
            default: mod.HandsontableSheetEditor
        })));
/**
 * Sheet editor using the adapter pattern.
 * The default adapter uses Handsontable for full spreadsheet functionality:
 * - Multi-sheet support with tabs
 * - Full grid editing with cell navigation
 * - CSV/custom format parsing
 *
 * This is a thin wrapper that passes props directly to HandsontableSheetEditor.
 * HandsontableSheetEditor handles parsing (string -> Sheet[]) and serialization (Sheet[] -> string).
 *
 * Note: Handsontable is lazy-loaded to improve initial drawer open performance.
 */ export function SheetArtifactEditor({ value, className, onChange }) {
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx("div", {
            className: "flex items-center justify-center h-full p-8",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "text-center space-y-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full mx-auto"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-muted-foreground",
                        children: "Loading spreadsheet editor..."
                    })
                ]
            })
        }),
        children: /*#__PURE__*/ _jsx(HandsontableSheetEditor, {
            value: value,
            className: className,
            onChange: onChange
        })
    });
}
